import * as z from "zod/v4";

export const hasRefundidIntegration = {
  name: "hasRefundidIntegration" as const,
  input: z.object({}).nullish(),
  output: z.object({ hasRefundidIntegration: z.boolean() }),
};
